import React, { useEffect, useState } from "react";
import { useConfigurationState } from "./hooks/useConfigurationState";
import { Button } from "src/business-types/grocery/components/Button";
import { useUser } from "../context/UserContext";
import InputBox from "src/business-types/grocery/components/InputBox";

function PosConfig() {
  const { userConfigration, user } = useUser();
  const toBoolean = (value: any) => value === true || value === "true";


  const { deliveryFeeEnabled, setDeliveryFeeEnabled, cardEnabled, savePosConfig, orderEditingEnabled, businessName, setBusinessName, creditControlEnabled, setCreditControlEnabled } = useConfigurationState();

  // Store initial values from API
  const [initialState, setInitialState] = useState({
    deliveryFeeEnabled: toBoolean(userConfigration.deliveryFeeEnabled) ?? false,
    cardEnabled: toBoolean(userConfigration.cardPayment) ?? false,
    orderEditingEnabled: toBoolean(userConfigration.orderEditingEnabled) ?? false,
    businessName: userConfigration.customBusinessName,
    creditControlEnabled: userConfigration.creditControlEnabled ?? false
  });

  // Update initial state whenever API data changes
  useEffect(() => {
    setInitialState({
      deliveryFeeEnabled: toBoolean(userConfigration.deliveryFeeEnabled),
      cardEnabled: toBoolean(userConfigration.cardPayment),
      orderEditingEnabled: toBoolean(userConfigration.orderEditingEnabled),
      businessName: userConfigration.customBusinessName ?? user?.businessType,
      creditControlEnabled: userConfigration.creditControlEnabled ?? false
    });
  }, [userConfigration]);


  // Enable Save button only when values change
  const isSaveButtonEnabled = deliveryFeeEnabled !== initialState.deliveryFeeEnabled || businessName !== initialState.businessName || creditControlEnabled !== initialState.creditControlEnabled;

  const handleSave = async () => {
    try {
      await savePosConfig({
        deliveryFeeEnabled,
        businessName: businessName
        // cardEnabled,
      });

      // Reset initial state after successful save
      setInitialState({
        deliveryFeeEnabled,
        cardEnabled,
        orderEditingEnabled,
        businessName,
        creditControlEnabled
      });
    } catch (error) {
      console.error("Failed to save configuration:", error);
    }
  };

  return (
    <div className="w-full p-4 overflow-y-auto">
      <div className="space-y-6 rounded-xl border bg-white p-6 shadow">
        <h2 className="text-xl font-bold">POS Configuration</h2>

        {/* Delivery Fee */}
        <>
          <div>
            <h3 className="mb-4 text-lg font-semibold">Delivery Fee</h3>

            <label className="flex cursor-pointer items-start gap-2 pl-1">
              <input type="checkbox" checked={deliveryFeeEnabled} onChange={() => setDeliveryFeeEnabled(!deliveryFeeEnabled)} className="mt-1 h-4 w-4" />

              <div>
                <span className="font-medium">Enable Delivery Fee</span>

                {!deliveryFeeEnabled && <p className="text-xs text-gray-500">Enable delivery fee to allow adding delivery charges to orders.</p>}
              </div>
            </label>
          </div>

          <div className="border-t"></div>
        </>
        {/* Custom Business Name - Grocery Only */}
        {user?.businessType === "Grocery" && (
          <div className="border-b pb-4">
            <h2 className="text-lg font-semibold mb-4">Custom Business Name</h2>

            <div className="max-w-xs">
              <label className="block text-sm font-medium mb-2">Business Name</label>
              <InputBox placeholder="Enter business name" onChange={(e) => setBusinessName(e.target.value)} value={businessName} />
            </div>
          </div>
        )}

        {user?.businessType === "Grocery" && (
          <div className="border-b pb-4">
            <h2 className="text-lg font-semibold mb-4">Enabled for Tailor Shop </h2>

            <div className="flex cursor-pointer items-start gap-2 pl-1">
              <input type="checkbox" checked={deliveryFeeEnabled} onChange={() => setDeliveryFeeEnabled(!deliveryFeeEnabled)} className="mt-1 h-4 w-4" />
              <span className="font-medium">Enable Admin Measurement </span>
            </div>
          </div>
        )}

        {/* <div className="border-b pb-4">
          <h2 className="text-lg font-semibold mb-4">Credit Control Enabled </h2>

          <div className="flex cursor-pointer items-start gap-2 pl-1">
            <input type="checkbox" checked={creditControlEnabled} onChange={() => setCreditControlEnabled(!creditControlEnabled)} className="mt-1 h-4 w-4" />
            <span className="font-medium">Enable Credit Control </span>
          </div>
        </div> */}
        {/* )} */}
        {/* {user?.businessType === "Grocery" && (
          <div className="ml-4 flex flex-col gap-2 shadow-inner rounded-md border border-gray-200 bg-gray-50 p-4">
            <h3 className="mb-2 text-lg font-bold">Order Editing</h3>
            <div className="flex items-center gap-2 p-2">
              <input type="checkbox" checked={orderEditingEnabled} onChange={() => setOrderEditingEnabled(!orderEditingEnabled)} />
              <p>Enable Order Editing</p>
            </div>
          </div>
        )} */}

        {/* Card Payment */}
        {/* <div>
                    <h3 className="mb-4 text-lg font-semibold">
                        Card Payment
                    </h3>

                    <label className="flex cursor-pointer items-start gap-2 pl-1">
                        <input
                            type="checkbox"
                            checked={cardEnabled}
                            onChange={() => setCardEnabled(!cardEnabled)}
                            className="mt-1 h-4 w-4"
                        />

                        <div>
                            <span className="font-medium">
                                Enable Card Payment
                            </span>

                            {!cardEnabled && (
                                <p className="text-xs text-gray-500">
                                    Enable card payment to allow customers to pay
                                    with credit/debit cards using Razorpay.
                                </p>
                            )}
                        </div>
                    </label>
                </div> */}

        {/* Save Button */}
        <div className="flex justify-center">
          <Button label="Save POS Configuration" onClick={handleSave} disabled={!isSaveButtonEnabled} variant="primary" />
        </div>
      </div>
    </div>
  );
}

export default PosConfig;
